import SelectionFolderItem from '../selection/folder_item_base';

export default class extends SelectionFolderItem {
  static targets = ['label'];

  render(dimension, selected, total) {
    this.inputFor(dimension).checked = selected > 0;

    const label = this.labelTargets.find((element) => element.dataset.dimension === dimension);
    if (label) {
      label.textContent = `${selected}/${total} ${label.dataset.plural}`;
    }
  }
}
